import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { getHeaderLocale } from '../src/WamazingUI/utils/i18n';
import { getLocaleFromSubdomain, getSubdomainFromNextLocale, Subdomain } from '../src/WamazingUI/utils/subdomain';
import { Footer } from '../src/components/footer';
import { LanguagesType } from '../src/models/languagesType';

document.addEventListener('turbolinks:load', () => {
  const userSubdomain = window.location.host.split('.')[0];
  const subdomain = getSubdomainFromNextLocale(userSubdomain);
  const locale = getLocaleFromSubdomain(subdomain);

  let lang:LanguagesType = getHeaderLocale(locale);

  // CN向けサイトが、国別のサブドメインを有さないため、CN向けサイトのみ特殊取扱
  if (window.location.host.includes('wamazing-cn.com')) {
    lang = getHeaderLocale(getLocaleFromSubdomain(Subdomain.CN));
  }

  if (document.querySelector('#wamazing-ui-footer')) {
    ReactDOM.render(<Footer lang={lang} />, document.querySelector('#wamazing-ui-footer'));
  }
});
